$w.onReady(function () {
	$w('#dropMenu').hide('slide', slideOptions);
    $w('#dropMenu2').hide('slide', slideOptions);
    $w('#megaMenu2').hide('slide', slideOptions);
});

let slideOptions = {
  "duration":   300,
  "delay":      0,
  "direction":  "top"
};

/* Mega Menu */

export function whoweare_mouseIn(event) {
	$w('#dropMenu').hide('slide', slideOptions);
    
    $w('#megaMenu2').show('slide', slideOptions);
}

export function megaMenu2_mouseOut(event) {
	$w('#megaMenu2').hide('slide', slideOptions);
}

/* What We Do */

export function whatwedo_mouseIn(event) {
	$w('#megaMenu2').hide('slide', slideOptions);
    $w('#dropMenu2').hide('slide', slideOptions);
    
    $w('#dropMenu').show('slide', slideOptions);
}

export function dropMenu_mouseOut(event) {
	$w('#dropMenu').hide('slide', slideOptions);
}

/* Get Involved */

export function getinvolved_mouseIn(event) {
	$w('#dropMenu').hide('slide', slideOptions);
    
    $w('#dropMenu2').show('slide', slideOptions); 
}

export function dropMenu2_mouseOut(event) {
	$w('#dropMenu2').hide('slide', slideOptions);
}

/* Header areas */

export function logo_mouseIn(event) {
	$w('#dropMenu').hide('slide', slideOptions);
    $w('#dropMenu2').hide('slide', slideOptions);
    $w('#megaMenu2').hide('slide', slideOptions);
}

export function donateSearch_mouseIn(event) {
	$w('#dropMenu').hide('slide', slideOptions);
    $w('#dropMenu2').hide('slide', slideOptions);
    $w('#megaMenu2').hide('slide', slideOptions); 
}